import React from 'react';

import Button from '../../../common/Button';

const ActionButton = (props) => {
  const {
    withoutPermission = false,
    permissions,
    permissionKey,
    loading = false,
    disabled = false,
    icon = null,
    action,
    classType,
    className = '',
    text,
  } = props;

  const available =
    !withoutPermission && permissions && permissions[permissionKey]
      ? permissions[permissionKey].value
      : true;
  const onClickAction = available ? action : () => false;
  if (available) {
    return (
      <Button
        className={className}
        classType={classType}
        text={text}
        disabled={disabled}
        loading={loading}
        icon={icon}
        onClick={onClickAction}
      />
    );
  } else {
    return (
      <div className="help-tooltip-wrapper" style={{ display: 'inline-block' }}>
        <Button
          className={className}
          classType={classType}
          text={text}
          icon={icon}
          disabled
          onClick={onClickAction}
        />
        <span className="help-tooltip" style={{ color: '#72747b', left: 0 }}>
          {permissions[permissionKey].reason}
        </span>
      </div>
    );
  }
};

export default ActionButton;
